import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-15" }
const _hoisted_2 = {
  key: 0,
  class: "mt-2 mb-4"
}
const _hoisted_3 = { class: "existing-error-message" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_breadcrumbs, { items: _ctx.breadcrumbs }, null, 8, ["items"]),
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('classDiary.createClassDiary')), 1),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "6" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, {
              modelValue: _ctx.classId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.classId) = $event)),
              items: _ctx.classes,
              "item-title": (item) => item.classId === undefined ? null : `(${item.year}) ${item.className}`,
              "item-value": "classId",
              variant: "outlined",
              "hide-details": "",
              density: "compact"
            }, null, 8, ["modelValue", "items", "item-title"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "6" }, {
          default: _withCtx(() => [
            _createVNode(_component_date_picker, {
              modelValue: _ctx.date,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.date) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.existingDiary)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.selectedClassName) + " " + _toDisplayString(_ctx.formattedDate) + " " + _toDisplayString(_ctx.$t('classDiary.alreadyExists')) + " ", 1),
            _createElementVNode("a", {
              class: "ml-4",
              href: `/class-diaries/${_ctx.existingDiary.classId}/${_ctx.existingDiary.classDiaryId}`
            }, _toDisplayString(_ctx.$t('classDiary.goToEditPage')), 9, _hoisted_4)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('classDiary.objective')), 1),
            _createVNode(_component_v_textarea, {
              variant: "outlined",
              modelValue: _ctx.aim,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.aim) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col)
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('classDiary.activitiesMorning')), 1),
            _createVNode(_component_v_textarea, {
              variant: "outlined",
              modelValue: _ctx.activityAm,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activityAm) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('classDiary.activitiesAfternoon')), 1),
            _createVNode(_component_v_textarea, {
              variant: "outlined",
              modelValue: _ctx.activityPm,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.activityPm) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('classDiary.evaluationReflection')), 1),
            _createVNode(_component_v_textarea, {
              variant: "outlined",
              modelValue: _ctx.assessment,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.assessment) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t('classDiary.parentSupport')), 1),
            _createVNode(_component_v_textarea, {
              variant: "outlined",
              modelValue: _ctx.support,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.support) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      (_ctx.isSaving)
        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
            key: 0,
            indeterminate: "",
            color: "primary",
            class: "my-8"
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_select, {
          variant: "outlined",
          label: _ctx.$t('schoolDiary.applicant'),
          items: _ctx.staffOptions,
          "item-value": "userId",
          "item-title": "name",
          modelValue: _ctx.appliedBy,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.appliedBy) = $event))
        }, null, 8, ["label", "items", "modelValue"]),
        _createVNode(_component_v_spacer)
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_btn, {
          color: "primary",
          variant: "outlined",
          "x-large": "",
          disabled: (!_ctx.isContentValid && !_ctx.isSaving) || _ctx.existingDiary,
          class: "mx-2",
          onClick: _ctx.createAsDraft
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('schoolDiary.saveAsDraft')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_v_btn, {
          color: "primary",
          variant: "flat",
          "x-large": "",
          disabled: 
          (!_ctx.isContentValid && !_ctx.isSaving) || _ctx.existingDiary || !_ctx.appliedBy
        ,
          class: "mx-2",
          onClick: _ctx.createAndApply
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('schoolDiary.saveAndApply')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_v_spacer)
      ]),
      _: 1
    })
  ]))
}